import { jsx } from 'react/jsx-runtime';
import { styled } from '@flex-design-system/stitches-react';
import { Primitive } from '@radix-ui/react-primitive';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { flex } from '../../utils/flex.vanilla.mjs';

const Flex = forwardRef(
  ({ className, inline, direction, align, justify, wrap, ...props }, ref) => {
    return /* @__PURE__ */ jsx(
      StyledDiv,
      {
        ref,
        "data-scope": "flex",
        className: classNames(
          flex({ inline, direction, align, justify, wrap }),
          className
        ),
        ...props
      }
    );
  }
);
const StyledDiv = styled(Primitive.div);
Flex.toString = () => '[data-scope="flex"]';
const Stack = Flex;

export { Flex, Stack };
//# sourceMappingURL=Flex.mjs.map
